(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ck-duo202-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('halo-colors-134')) {
    customElements.define('halo-colors-134', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const rail = this.querySelector('[data-hc134-rail]');
        if (!rail) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const cards = [...rail.querySelectorAll('[data-hc134-index]')];
        const tabs = [...this.querySelectorAll('[data-hc134-tab]')];
        const dots = [...this.querySelectorAll('[data-hc134-dot]')];
        const previous = this.querySelector('[data-hc134-prev]');
        const next = this.querySelector('[data-hc134-next]');
        let current = 0;
        let frame = 0;

        const update = () => {
          frame = 0;
          const railLeft = rail.getBoundingClientRect().left;
          current = cards.reduce((best, card, index) => (
            Math.abs(card.getBoundingClientRect().left - railLeft) < Math.abs(cards[best].getBoundingClientRect().left - railLeft) ? index : best
          ), 0);
          tabs.forEach((tab, index) => tab.setAttribute('aria-pressed', String(index === current)));
          dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
          if (previous) previous.disabled = current === 0;
          if (next) next.disabled = current === cards.length - 1;
        };

        const go = (target) => {
          const index = Math.max(0, Math.min(cards.length - 1, target));
          const offset = cards[index].getBoundingClientRect().left - rail.getBoundingClientRect().left;
          rail.scrollTo({
            left: rail.scrollLeft + offset,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        };

        tabs.forEach((tab, index) => tab.addEventListener('click', () => go(index), { signal }));
        dots.forEach((dot, index) => dot.addEventListener('click', () => go(index), { signal }));
        previous?.addEventListener('click', () => go(current - 1), { signal });
        next?.addEventListener('click', () => go(current + 1), { signal });
        rail.addEventListener('scroll', () => {
          if (!frame) frame = requestAnimationFrame(update);
        }, { signal, passive: true });
        rail.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            go(current + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, { signal });
        update();
        this.cancelFrame = () => cancelAnimationFrame(frame);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.cancelFrame?.();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-duo202-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('duo-click-videos')) {
  customElements.define('duo-click-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const rail = this.querySelector('[data-hc134-rail]');
      const videos = [...this.querySelectorAll('video')];
      const pauseAll = () => videos.forEach(v => v.pause());
      this.addEventListener('click', event => {
        if (event.target.closest('[data-hc134-prev],[data-hc134-next],[data-hc134-dot]')) pauseAll();
        const button = event.target.closest('[data-duo-play]');
        if (!button) return;
        const media = button.closest('.ck-duo-videos__media');
        const video = media.querySelector('video');
        pauseAll();
        media.querySelector('[role=status]').hidden = true;
        if (!video.getAttribute('src')) video.src = video.dataset.duoSrc;
        else if (video.error) video.load();
        video.hidden = false;
        button.hidden = true;
        video.play().catch(error => {
          if (error.name === 'AbortError') return;
          video.hidden = true;
          button.hidden = false;
          media.querySelector('[role=status]').hidden = false;
        });
      }, {signal});
      videos.forEach(video => {
        video.addEventListener('play', () => videos.forEach(other => { if (other !== video) other.pause(); }), {signal});
        video.addEventListener('keydown', event => event.stopPropagation(), {signal});
        video.addEventListener('error', () => {
          video.hidden = true;
          video.parentElement.querySelector('[data-duo-play]').hidden = false;
          video.parentElement.querySelector('[role=status]').hidden = false;
        }, {signal});
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => { if (entry.intersectionRatio < .6) entry.target.querySelector('video').pause(); });
        }, {root:rail,threshold:[.6]});
        rail.querySelectorAll('article').forEach(slide => this.observer.observe(slide));
      }
      document.addEventListener('visibilitychange', () => { if (document.hidden) pauseAll(); }, {signal});
      this.pauseAll = pauseAll;
    }
    disconnectedCallback() {
      this.pauseAll?.();
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-frost-comparison"]) return;
  try {
    
if (!customElements.get('ck-frost-comparison')) {
  customElements.define('ck-frost-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const rail=this.querySelector('.ckfc-rail'), slides=[...this.querySelectorAll('.ckfc-slide')];
      if (!rail || !slides.length) return;
      const videos=slides.map(s=>s.querySelector('video')), tabs=[...this.querySelectorAll('[data-select]')], dots=[...this.querySelectorAll('[data-dot]')], prev=this.querySelector('[data-prev]'), next=this.querySelector('[data-next]'), listeners=[];
      let selected=0,inView=false,raf=0;
      const started=new Set();
      const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData;
      const on=(el,type,fn,options)=>{el.addEventListener(type,fn,options);listeners.push(()=>el.removeEventListener(type,fn,options));};
      const button=i=>{const v=videos[i];slides[i].querySelector('.ckfc-play').textContent=v.paused?(v.ended?this.dataset.replay:this.dataset.play):this.dataset.pause;};
      const prepare=i=>{const v=videos[i];if(!v.getAttribute('src')){v.preload='auto';v.src=v.dataset.src;v.load();}};
      const warm=()=>videos.forEach((v,i)=>prepare(i));
      const start=i=>{const v=videos[i];slides[i].querySelector('.ckfc-error').hidden=true;prepare(i);started.add(i);if(v.ended)v.currentTime=0;v.muted=true;v.play().then(()=>{if(document.hidden||i!==selected||!inView)v.pause();}).catch(()=>button(i));};
      const sync=()=>{tabs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===selected)));dots.forEach((b,i)=>b.setAttribute('aria-current',String(i===selected)));slides.forEach((s,i)=>s.inert=i!==selected);prev.disabled=selected===0;next.disabled=selected===slides.length-1;};
      const activate=i=>{if(i===selected)return;videos[selected].pause();selected=i;sync();if(inView&&!document.hidden&&!reduced()&&!started.has(i))start(i);};
      const go=i=>{i=Math.max(0,Math.min(slides.length-1,i));activate(i);rail.scrollTo({left:rail.clientWidth*i,behavior:'instant'});const bar=tabs[i].parentElement;bar.scrollTo({left:Math.max(0,tabs[i].offsetLeft-bar.offsetLeft-(bar.clientWidth-tabs[i].offsetWidth)/2),behavior:'instant'});};
      tabs.forEach((b,i)=>on(b,'click',()=>go(i)));dots.forEach((b,i)=>on(b,'click',()=>go(i)));
      on(prev,'click',()=>go(selected-1));on(next,'click',()=>go(selected+1));
      on(rail,'scroll',()=>{if(raf)return;raf=requestAnimationFrame(()=>{raf=0;activate(Math.max(0,Math.min(slides.length-1,Math.round(rail.scrollLeft/rail.clientWidth))));});},{passive:true});
      videos.forEach((v,i)=>{['play','pause','ended'].forEach(e=>on(v,e,()=>button(i)));on(v,'loadeddata',()=>slides[i].querySelector('.ckfc-stage').setAttribute('data-ready',''));on(v,'error',()=>{slides[i].querySelector('.ckfc-error').hidden=false;button(i);});on(slides[i].querySelector('.ckfc-play'),'click',()=>v.paused?start(i):v.pause());});
      const predecessor=this.closest('.shopify-section')?.previousElementSibling;
      const preloadObserver=new IntersectionObserver(es=>{if(es.some(e=>e.isIntersecting)){warm();preloadObserver.disconnect();}},{threshold:0});
      preloadObserver.observe(predecessor||this);
      const observer=new IntersectionObserver(es=>{inView=es[0].isIntersecting&&es[0].intersectionRatio>=.3;if(inView){warm();if(!document.hidden&&!reduced()&&!started.has(selected))start(selected);}else videos.forEach(v=>v.pause());},{threshold:[0,.3]});
      observer.observe(rail);
      const resize=new ResizeObserver(()=>rail.scrollTo({left:rail.clientWidth*selected,behavior:'instant'}));resize.observe(rail);
      on(document,'visibilitychange',()=>{if(document.hidden)videos.forEach(v=>v.pause());});
      sync();this.cleanup=()=>{preloadObserver.disconnect();observer.disconnect();resize.disconnect();listeners.forEach(fn=>fn());cancelAnimationFrame(raf);videos.forEach(v=>v.pause());};
    }
    disconnectedCallback(){this.cleanup?.();this.cleanup=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-frost130-detail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('frost-detail-130')) {
    customElements.define('frost-detail-130', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const rail = this.querySelector('[data-f130-rail]');
        if (!rail) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const cards = [...rail.querySelectorAll('[data-f130-index]')];
        const tabs = [...this.querySelectorAll('[data-f130-tab]')];
        const dots = [...this.querySelectorAll('[data-f130-dot]')];
        const previous = this.querySelector('[data-f130-prev]');
        const next = this.querySelector('[data-f130-next]');
        let current = 0;
        let frame = 0;

        const update = () => {
          frame = 0;
          const railLeft = rail.getBoundingClientRect().left;
          current = cards.reduce((best, card, index) => (
            Math.abs(card.getBoundingClientRect().left - railLeft) < Math.abs(cards[best].getBoundingClientRect().left - railLeft) ? index : best
          ), 0);
          tabs.forEach((tab, index) => tab.setAttribute('aria-pressed', String(index === current)));
          dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
          if (previous) previous.disabled = current === 0;
          if (next) next.disabled = current === cards.length - 1;
        };

        const go = (target) => {
          const index = Math.max(0, Math.min(cards.length - 1, target));
          const offset = cards[index].getBoundingClientRect().left - rail.getBoundingClientRect().left;
          rail.scrollTo({
            left: rail.scrollLeft + offset,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        };

        tabs.forEach((tab, index) => tab.addEventListener('click', () => go(index), { signal }));
        dots.forEach((dot, index) => dot.addEventListener('click', () => go(index), { signal }));
        previous?.addEventListener('click', () => go(current - 1), { signal });
        next?.addEventListener('click', () => go(current + 1), { signal });
        rail.addEventListener('scroll', () => {
          if (!frame) frame = requestAnimationFrame(update);
        }, { signal, passive: true });
        rail.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            go(current + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, { signal });
        update();
        this.cancelFrame = () => cancelAnimationFrame(frame);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.cancelFrame?.();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-halloween-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ck-halloween-collection')) {
  customElements.define('ck-halloween-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const grid = this.querySelector('[data-grid]');
      const cards = Array.from(grid.querySelectorAll('[data-card]'));
      const stock = this.querySelector('[data-stock]');
      const sort = this.querySelector('[data-sort]');
      const count = this.querySelector('[data-count]');
      const update = () => {
        const ordered = [...cards];
        if (sort.value === 'price-asc') ordered.sort((a,b) => Number(a.dataset.price) - Number(b.dataset.price));
        if (sort.value === 'price-desc') ordered.sort((a,b) => Number(b.dataset.price) - Number(a.dataset.price));
        let visible = 0;
        ordered.forEach(card => {
          card.hidden = stock.checked && card.dataset.available !== 'true';
          if (!card.hidden) visible++;
          grid.appendChild(card);
        });
        count.textContent = `${visible} ${count.dataset.label}`;
        this.querySelector('[data-empty]').hidden = visible > 0;
      };
      stock.addEventListener('change', update);
      sort.addEventListener('change', update);
      this.querySelector('[data-controls]').hidden = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-halo134-colors"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('halo-colors-134')) {
    customElements.define('halo-colors-134', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const rail = this.querySelector('[data-hc134-rail]');
        if (!rail) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const cards = [...rail.querySelectorAll('[data-hc134-index]')];
        const tabs = [...this.querySelectorAll('[data-hc134-tab]')];
        const dots = [...this.querySelectorAll('[data-hc134-dot]')];
        const previous = this.querySelector('[data-hc134-prev]');
        const next = this.querySelector('[data-hc134-next]');
        let current = 0;
        let frame = 0;

        const update = () => {
          frame = 0;
          const railLeft = rail.getBoundingClientRect().left;
          current = cards.reduce((best, card, index) => (
            Math.abs(card.getBoundingClientRect().left - railLeft) < Math.abs(cards[best].getBoundingClientRect().left - railLeft) ? index : best
          ), 0);
          tabs.forEach((tab, index) => tab.setAttribute('aria-pressed', String(index === current)));
          dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
          if (previous) previous.disabled = current === 0;
          if (next) next.disabled = current === cards.length - 1;
        };

        const go = (target) => {
          const index = Math.max(0, Math.min(cards.length - 1, target));
          const offset = cards[index].getBoundingClientRect().left - rail.getBoundingClientRect().left;
          rail.scrollTo({
            left: rail.scrollLeft + offset,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        };

        tabs.forEach((tab, index) => tab.addEventListener('click', () => go(index), { signal }));
        dots.forEach((dot, index) => dot.addEventListener('click', () => go(index), { signal }));
        previous?.addEventListener('click', () => go(current - 1), { signal });
        next?.addEventListener('click', () => go(current + 1), { signal });
        rail.addEventListener('scroll', () => {
          if (!frame) frame = requestAnimationFrame(update);
        }, { signal, passive: true });
        rail.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            go(current + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, { signal });
        update();
        this.cancelFrame = () => cancelAnimationFrame(frame);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.cancelFrame?.();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-halo18-detail"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('halo-detail-130'))customElements.define('halo-detail-130',class extends HTMLElement{
 connectedCallback(){if(this.controller)return;const rail=this.querySelector('[data-h130-rail]');if(!rail)return;this.controller=new AbortController();const signal=this.controller.signal,tabs=[...this.querySelectorAll('[data-h130-tab]')],cards=[...rail.children],prev=this.querySelector('[data-h130-prev]'),next=this.querySelector('[data-h130-next]');let current=0,frame=0;const update=()=>{frame=0;const left=rail.getBoundingClientRect().left;current=cards.reduce((best,card,i)=>Math.abs(card.getBoundingClientRect().left-left)<Math.abs(cards[best].getBoundingClientRect().left-left)?i:best,0);tabs.forEach((tab,i)=>tab.setAttribute('aria-pressed',String(i===current)));prev.disabled=current===0;next.disabled=current===cards.length-1;};const go=i=>{i=Math.max(0,Math.min(cards.length-1,i));rail.scrollTo({left:rail.scrollLeft+cards[i].getBoundingClientRect().left-rail.getBoundingClientRect().left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};tabs.forEach((tab,i)=>tab.addEventListener('click',()=>go(i),{signal}));prev.addEventListener('click',()=>go(current-1),{signal});next.addEventListener('click',()=>go(current+1),{signal});rail.addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(update)},{signal,passive:true});rail.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(current+(e.key==='ArrowRight'?1:-1));}},{signal});this.addEventListener('shopify:block:select',e=>{const i=cards.findIndex(c=>c.id.endsWith(e.detail.blockId));if(i>=0)go(i)},{signal});this.cancelFrame=()=>cancelAnimationFrame(frame);update();}
 disconnectedCallback(){this.controller?.abort();this.controller=null;this.cancelFrame?.();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-texture134-detail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('texture-detail-134')) {
    customElements.define('texture-detail-134', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const rail = this.querySelector('[data-tm134-rail]');
        if (!rail) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const cards = [...rail.querySelectorAll('[data-tm134-index]')];
        const tabs = [...this.querySelectorAll('[data-tm134-tab]')];
        const dots = [...this.querySelectorAll('[data-tm134-dot]')];
        const previous = this.querySelector('[data-tm134-prev]');
        const next = this.querySelector('[data-tm134-next]');
        let current = 0;
        let frame = 0;

        const update = () => {
          frame = 0;
          const railLeft = rail.getBoundingClientRect().left;
          current = cards.reduce((best, card, index) => (
            Math.abs(card.getBoundingClientRect().left - railLeft) < Math.abs(cards[best].getBoundingClientRect().left - railLeft) ? index : best
          ), 0);
          tabs.forEach((tab, index) => tab.setAttribute('aria-pressed', String(index === current)));
          dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
          if (previous) previous.disabled = current === 0;
          if (next) next.disabled = current === cards.length - 1;
        };

        const go = (target) => {
          const index = Math.max(0, Math.min(cards.length - 1, target));
          const offset = cards[index].getBoundingClientRect().left - rail.getBoundingClientRect().left;
          rail.scrollTo({
            left: rail.scrollLeft + offset,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        };

        tabs.forEach((tab, index) => tab.addEventListener('click', () => go(index), { signal }));
        dots.forEach((dot, index) => dot.addEventListener('click', () => go(index), { signal }));
        previous?.addEventListener('click', () => go(current - 1), { signal });
        next?.addEventListener('click', () => go(current + 1), { signal });
        rail.addEventListener('scroll', () => {
          if (!frame) frame = requestAnimationFrame(update);
        }, { signal, passive: true });
        rail.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            go(current + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, { signal });
        update();
        this.cancelFrame = () => cancelAnimationFrame(frame);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.cancelFrame?.();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck190-contrast-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ck190-story'))customElements.define('ck190-story',class extends HTMLElement{
connectedCallback(){
if(this.cleanup)return;
const rail=this.querySelector('.ck190-rail'),slides=[...this.querySelectorAll('.ck190-slide')];
if(!rail||slides.length<2)return;
const tabs=[...this.querySelectorAll('[data-tab]')],dots=[...this.querySelectorAll('[data-dot]')],prev=this.querySelector('[data-prev]'),next=this.querySelector('[data-next]'),off=[];
let selected=0,raf=0;
const on=(el,type,fn,options)=>{el?.addEventListener(type,fn,options);off.push(()=>el?.removeEventListener(type,fn,options));};
const step=()=>slides.length>1?slides[1].offsetLeft-slides[0].offsetLeft:rail.clientWidth;
const sync=()=>{tabs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===selected)));dots.forEach((b,i)=>b.setAttribute('aria-current',String(i===selected)));if(prev)prev.disabled=rail.scrollLeft<2;if(next)next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;};
const go=i=>{selected=Math.max(0,Math.min(slides.length-1,i));rail.scrollTo({left:step()*selected,behavior:'instant'});sync();const tab=tabs[selected];if(tab){const bar=tab.parentElement;bar.scrollTo({left:Math.max(0,tab.offsetLeft-bar.offsetLeft-(bar.clientWidth-tab.offsetWidth)/2),behavior:'instant'});}};
tabs.forEach((b,i)=>on(b,'click',()=>go(i)));dots.forEach((b,i)=>on(b,'click',()=>go(i)));
on(prev,'click',()=>go(selected-1));on(next,'click',()=>go(selected+1));
on(rail,'scroll',()=>{if(raf)return;raf=requestAnimationFrame(()=>{raf=0;selected=Math.min(slides.length-1,Math.round(rail.scrollLeft/step()));sync();});},{passive:true});
on(rail,'keydown',e=>{if(e.target!==rail)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(selected+(e.key==='ArrowRight'?1:-1));}});
const resize=typeof ResizeObserver==='function'?new ResizeObserver(()=>go(selected)):null;resize?.observe(rail);sync();
this.cleanup=()=>{off.forEach(fn=>fn());resize?.disconnect();cancelAnimationFrame(raf);};
}
disconnectedCallback(){this.cleanup?.();this.cleanup=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-article-group"] && !Shopify.designMode) return;
  try {
    
  class NewsArticles extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      const apiPrefix = window.Shopify.routes.root
      // fetch(apiPrefix + "blogs/news?section_id=main-blogs",{
      //   method: 'GET'
      // }).then(res => {
      //   return res.json()
      // }).then(res => {
      //   console.log("res", res)
      // }).catch(e => {
      //   console.log("e", e)
      // })
      // let sliders = this.querySelectorAll('.swiper-slide');

      // fetch(apiPrefix + 'admin/api/blogs/news')
      // .then(response => response.json())
      // .then(data => {
      //   console.log(data);
      //   // Process the data as needed
      // })
      // .catch(error => console.error('Error fetching articles:', error));
      
    }
  }
  if (!customElements.get('q-news-articles')) {
    customElements.define('q-news-articles', NewsArticles);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-article-search"] && !Shopify.designMode) return;
  try {
    
  class SearchArticles extends HTMLElement {
    constructor() {
      super();
      this.oInp = this.querySelector('.qbse-input');
      this.oGrid = this.querySelector('.qbse-grid');
      this.card_color = this.getAttribute('card_color');
      this.timer = null
      this.oInp.oninput = () => {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.search()
        }, 600);
      }
    }

    search () {
      let query = this.oInp.value
      if (query) {
        this.oGrid.setAttribute("ing", "1")
        const apiPrefix = window.Shopify.routes.root
        fetch(apiPrefix + `search/suggest.json?q=${query}&resources[type]=article&resources[limit]=9 `,{
          method: 'GET'
        }).then(res => {
          return res.json()
        }).then(res => {
          this.oGrid.setAttribute("ing", "")
          // console.log("res", res)
          let list = res.resources.results.articles
          // console.log(list.length)
          let html = ``
          list.forEach(item => {
            // console.log(item)
            let publishedDate = new Date(item.published_at);
            let formattedDate = `${publishedDate.getDate()}/${publishedDate.getMonth() + 1}/${publishedDate.getFullYear()}`;
            
            let tempDiv = document.createElement("div");
            tempDiv.innerHTML = item.body;
            let textContent = tempDiv.textContent || tempDiv.innerText || "";
            textContent = textContent.slice(0, 100)
            html += `
              <div>
                <a class="qar-wrap" href="${item.url}" style="--bg: ${this.card_color}">
                  <div class="qar-img-wrap">
                    <img class="full-img" src="${item.image}" alt="${item.title}">
                  </div>
                  <h3 class="qar-title">${item.title}</h3>
                  <p class="qar-content">${textContent}</p>
                  <div class="qar-footer">
                    <span>${item.author}</span>
                    <span>${formattedDate}</span>
                  </div>
                </a>
              </div>
            `
          })
          this.oGrid.innerHTML = html
        }).catch(e => {
          this.oGrid.setAttribute("ing", "")
          console.log("e", e)
        })
      }

    }
  }
  if (!customElements.get('q-articles-search')) {
    customElements.define('q-articles-search', SearchArticles);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-blogs-anchor"] && !Shopify.designMode) return;
  try {
    
class ProductAnchor extends HTMLElement {
  constructor() {
    super();
    this.navBtns = this.querySelectorAll(".qaan-top-btn")
    this.init()
  }
  init () {
    window.addEventListener("scroll", () => {
      let t = document.documentElement.scrollTop + 0
      let oWrap = this.querySelector('.qaan-wrap')
      let oFixed = this.querySelector('.qaan-fixed')
      // let top = oWrap.offsetTop
      let top = oWrap.getBoundingClientRect().top
      // console.log(top, t)
      if (top < 0) {
      // if (top < t) {
        // oFixed.setAttribute("show", "1")
      } else {
        oFixed.setAttribute("show", "")
      }
    })

    let ob = new IntersectionObserver((e) => {
      let entry = e[0]
      if (entry.isIntersecting) {
        this.navBtns.forEach((ite) => {
          ite.setAttribute("show", "")
        })
        this.navBtns.forEach((item,i) => {
          if (item.getAttribute('data-id') === entry.target.getAttribute("id")) {
            item.setAttribute('show', "1")
          }
        })
      }
    }, {
      threshold: 1
    })

    this.navBtns.forEach((item,i) => {
      let id = item.getAttribute("data-id")
      let dom = document.querySelector("#" + id)
      if (dom) {
        // ob.observe(dom)
      }
      item.addEventListener("click", () => {
        const rect = dom.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const elementOffsetTop = rect.top + scrollTop;
        let top = elementOffsetTop
        window.scrollTo({
          top: top - 100,
          behavior: "smooth"
        })
      })
    })
  }
}
if (!customElements.get('q-product-anchor')) {
  customElements.define('q-product-anchor', ProductAnchor);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-new-article"] && !Shopify.designMode) return;
  try {
    
  class NewsArticles extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {

    }
  }
  if (!customElements.get('q-news-articles')) {
    customElements.define('q-news-articles', NewsArticles);
  }

  } catch(e) { console.error(e); }
})();
})();
